export default __webpack_public_path__ + "static/media/SFProDisplay-Bold.84c242fe.woff2";